import { db } from './db';

function bookmarkKey(eventId: string): string {
  return `sessionBookmarks:${eventId}`;
}

/** Get session IDs the user bookmarked ("want to go") for an event. */
export async function getSessionBookmarks(eventId: string): Promise<Set<string>> {
  const setting = await db.userSettings.get(bookmarkKey(eventId));
  if (!setting?.value) return new Set();
  try {
    const ids = JSON.parse(setting.value) as string[];
    return new Set(Array.isArray(ids) ? ids : []);
  } catch {
    return new Set();
  }
}

/** Toggle bookmark for a session. Returns the new bookmarked state. */
export async function toggleSessionBookmark(
  eventId: string,
  sessionId: string
): Promise<boolean> {
  const bookmarks = await getSessionBookmarks(eventId);
  const next = !bookmarks.has(sessionId);
  if (next) {
    bookmarks.add(sessionId);
  } else {
    bookmarks.delete(sessionId);
  }
  await db.userSettings.put({
    key: bookmarkKey(eventId),
    value: JSON.stringify([...bookmarks]),
  });
  return next;
}
